module.exports = __webpack_public_path__ + "static/media/teaching_server_icon_4.bfef1fda.svg";